import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=5141ee6c"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=5141ee6c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5141ee6c')) {
      api.createRecord('5141ee6c', component.options)
    } else {
      api.reload('5141ee6c', component.options)
    }
    module.hot.accept("./LanguageDropdown.vue?vue&type=template&id=5141ee6c", function () {
      api.rerender('5141ee6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-navbar/components/dropdowns/LanguageDropdown.vue"
export default component.exports